// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import routes from './routes'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import store from './store/'
import components from './comps/' // 加载公共组件
import VueScroller from 'vue-scroller'
import resource from './pg/resource'
import scheme from './pg/scheme'
import { Rate, Input } from 'element-ui'
import { WE_OAUTH_URL } from './api'
import {Dialog} from 'vant'
import 'vant/lib/index.css'

Object.keys(components).forEach((key) => {
  Vue.component(`v-${key}`, components[key])
})

Vue.use(Dialog)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueScroller)
Vue.use(Rate)
Vue.use(Input)
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})
const router = new VueRouter({routes})
router.beforeEach(({meta, path}, from, next) => {
  console.log(`next: ${path}`)
  var { auth = true } = meta
  var isLogin = Boolean(store.state.user.userId) // true用户已登录， false用户未登录
  if (auth && !isLogin && path !== '/login') {
    let ua = window.navigator.userAgent.toLowerCase()
    window.localStorage.setItem('path-after-login', path)
    if (/micromessenger/.test(ua)) {
      window.location.href = WE_OAUTH_URL
    } else {
      return next({ path: '/login' })
    }
  }
  next()
})
// VueRouter.prototype.goBack = function () {
//   this.isBack = true
//   this.go(-1)
// }
window.resource = resource
window.$router = router
window.$store = store
window.$scheme = scheme
new Vue({
  store,
  router,
  data: {
    eventHub: new Vue()
  }
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js